import { App } from 'vue'
import Forms from './forms'
import Control from './control'
import I from './i'
import Ui from './ui'
import Pages from './pages'
import Parts from './parts'
import Elements from './elements'

export default {
  install(app: App<Element>): void {
    Pages.register(app)
    Forms.register(app)
    Control.register(app)
    I.register(app)
    Ui.register(app)
    Parts.register(app)
    Elements.register(app)
  }
}
